import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useRouter } from 'next/router';
import { wrapper } from 'store';
import DocumentHead from 'components/DocumentHead';

import { setProfile } from 'features/profilesSlice';
import axios from 'utils/axios';
import useScrollToTop from 'hooks/useScrollToTop';
import FanProfile from 'components/profile/FanProfile';

const FansPage = () => {
  const router = useRouter();
  const { username } = router.query;
  const profile = useSelector(state => state.profiles.mapping[username.toLowerCase()]);
  const dispatch = useDispatch();

  useScrollToTop();

  return (
    <>
      <DocumentHead>
        <title>{profile.display_name} | GigSocial</title>
      </DocumentHead>

      <FanProfile profile={profile} setProfile={profile => dispatch(setProfile(profile))} />
    </>
  );
};

export const getServerSideProps = wrapper.getServerSideProps(store => async context => {
  const { params } = context;
  const { username } = params;

  try {
    const response = await axios.get(`/v1/profiles/${username}/public_profile`);
    store.dispatch(setProfile(response.data));
  } catch (error) {
    return {
      redirect: {
        destination: '/',
        permanent: false,
      },
    };
  }
});

export default FansPage;
